module.exports = __webpack_public_path__ + "img/equipment.98d2e190.svg";